module.exports = __webpack_public_path__ + "static/media/agriculture.273262a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/TeamBox/img/agriculture.svg
// module id = 77
// module chunks = 0